import { PlanInterval } from '../../types/PlanInterval'

export function deserializePlanIntervalQueryParam(
  value: string | undefined
): PlanInterval | undefined {
  switch (value?.toUpperCase()) {
    case 'MONTHLY':
      return PlanInterval.MONTHLY
    case 'YEARLY':
      return PlanInterval.YEARLY
  }
}
